import styled from "styled-components";

export const Modal = styled.div``;

export const Title = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin: 8px 0;
`;